import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'

import '../src/plugins/element'
import LocalStorage from './utils/localStorage';

import * as echarts from 'echarts'

import 'highlight.js/styles/atom-one-dark.css'

import VueParticles from 'vue-particles'
Vue.use(VueParticles)


Vue.prototype.$localStorage = LocalStorage;
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$bus = new Vue({})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
